module.exports = __webpack_public_path__ + "static/media/optional-settings-white.4795e859.svg";